// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationTemplateRevisionId } from './HarvestOperationTemplateRevision';
import { sampleTemplateType } from './SampleTemplateType';
import { z } from 'zod';
export const sampleTemplateId = (z.number());
export const sampleTemplate = z.object({
    id: sampleTemplateId,
    harvest_operation_template_id: harvestOperationTemplateRevisionId,
    name: z.string(),
    abbreviation: z.string(),
    type: sampleTemplateType,
    default_labels: z.string().array().nullable(),
    default_replicates: z.number(),
    description: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const sampleTemplateInitializer = z.object({
    id: sampleTemplateId.optional(),
    harvest_operation_template_id: harvestOperationTemplateRevisionId,
    name: z.string(),
    abbreviation: z.string(),
    type: sampleTemplateType,
    default_labels: z.string().array().optional().nullable(),
    default_replicates: z.number().optional(),
    description: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const sampleTemplateMutator = z.object({
    id: sampleTemplateId.optional(),
    harvest_operation_template_id: harvestOperationTemplateRevisionId.optional(),
    name: z.string().optional(),
    abbreviation: z.string().optional(),
    type: sampleTemplateType.optional(),
    default_labels: z.string().array().optional().nullable(),
    default_replicates: z.number().optional(),
    description: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=SampleTemplate.js.map